import { createFileRoute } from "@tanstack/react-router";
import PageGate from "@/components/auth/PageGate";
import IntelligenceAnalysts from "@/pages/IntelligenceAnalysts";

export const Route = createFileRoute("/_app/intelligence/analysts/")({
  component: () => (
    <PageGate pageKey="intelligence"><IntelligenceAnalysts /></PageGate>
  ),
});
